import React, { Component } from "react";
import Swal from "sweetalert2";
import {
  AiOutlineCheck
} from "react-icons/ai";

import "./PreSalePicking.css";
import { getInformationWithData } from "../services/CABE";
import { Menu } from "../components/Menu/Menu";

class PreSalePicking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOrder: null,
      loadingPreSale: false
    };
  }

  componentDidMount() {
    // asume query param ?orderNo=XXXX
    const params = new URLSearchParams(window.location.search);
    const orderNo = params.get("orderNo");

    if (orderNo) {
      this.loadOrder(orderNo);
    }
  }

  loadOrder = async (orderNo) => {
    this.setState({ loadingPreSale: true });

    const data = { orderNo };

    try {
        const result = await getInformationWithData("/pre-sales/single-order", data);

        if (result && result.data && result.data.data) {

            const order = {...result.data.data[0], items: []};

            // Update order
            this.setState(
                {
                    selectedOrder: order,
                },
                () => {
                    // Load details
                    this.loadOrderDetails(order);
                }
            );
        } else {
            throw new Error("Invalid response");
        }

    } catch (e) {
      this.setState({ loadingPreSale: false });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load order"
      });
    }
  }

  loadOrderDetails = async (order) => {
    const data = { orderNo: order.order_no };

    try {
      const result = await getInformationWithData("/pre-sales/details/order", data);

      if (result && result.data && result.data.data) {
        const items = result.data.data.map(function (item) {
          return {
            ...item,
            picked_quantity: item.quantity
          };
        });

        this.setState({
          selectedOrder: {
            ...order,
            items: items,
          },
          loadingPreSale: false
        });
      } else {
        throw new Error("Invalid response");
      }

    } catch (e) {
      this.setState({ loadingPreSale: false });

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Could not load order"
      });
    }
  };

  handleQtyChange = (index, value) => {
    const order = { ...this.state.selectedOrder };

    const val = parseInt(value, 10);

    order.items[index].picked_quantity = isNaN(val) || val < 0 ? 0 : val;

    this.setState({ selectedOrder: order });
  };

  confirmPicking = () => {
    const order = this.state.selectedOrder;

    Swal.fire({
      icon: "question",
      title: "Confirm picking?",
      text: "This will confirm quantities",
      showCancelButton: true,
      confirmButtonText: "Yes, confirm"
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      this.setState({ loadingPreSale: true });

      const data = {
        orderNo: order.order_no,
        items: order.items.map(function (item) {
          return {
            itemCode: item.item_code,
            quantity: item.picked_quantity
          };
        })
      };

      try {
        await getInformationWithData("/pre-sales/picking/confirm", data);

        this.setState({ loadingPreSale: false });

        Swal.fire({
          icon: "success",
          title: "Picking completed"
        });

        window.location.href = "/pre-sales/orders";

      } catch (e) {
        this.setState({ loadingPreSale: false });

        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Could not confirm picking"
        });
      }
    });
  };

  render() {
    const selectedOrder = this.state.selectedOrder;

    return (
      <div>
        <Menu Refresh={this.state.Refresh} Father={this} />

        {this.state.loadingPreSale && (
          <div className="loading-overlay">
            <div className="loading-box">
              <div className="spinner"></div>
              <div className="loading-text">Processing...</div>
            </div>
          </div>
        )}

        <div className="pol-page" style={{ marginTop: 70 }}>
          <div className="pol-shell">

            {selectedOrder ? (
              <div>

                <div className="pol-header">
                  <div>
                    <h1 className="pol-title">
                      Picking · {selectedOrder.order_no}
                    </h1>
                    <p className="pol-subtitle">
                      Confirm product quantities for this order
                    </p>
                  </div>
                </div>

                {/* INFO */}
                <div className="pol-details-grid">
                  <div className="pol-detail-card">
                    <h4>General</h4>

                    <div className="pol-kv">
                      <span>Order</span>
                      <strong>{selectedOrder.order_no}</strong>
                    </div>

                    <div className="pol-kv">
                      <span>Customer</span>
                      <strong>{selectedOrder.customer_name} · {selectedOrder.customer_no}</strong>
                    </div>

                    <div className="pol-kv">
                      <span>Date</span>
                      <strong>{selectedOrder.date}</strong>
                    </div>
                  </div>

                  <div className="pol-detail-card">
                    <h4>Totals</h4>

                    <div className="pol-kv">
                      <span>Total Qty</span>
                      <strong>{selectedOrder.totalQuantity}</strong>
                    </div>

                    <div className="pol-kv">
                      <span>Total Amount</span>
                      <strong>${selectedOrder.totalAmount}</strong>
                    </div>
                  </div>
                </div>

                {/* PRODUCTS */}
                <div className="pol-items-section">
                  <h4>Products</h4>

                  <div className="pol-table-wrap">
                    <table className="pol-table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Item</th>
                          <th>Description</th>
                          <th>Requested</th>
                          <th>Picking</th>
                        </tr>
                      </thead>

                      <tbody>
                        {selectedOrder.items.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <img src={item.image_url} style={{ height: 30 }} alt={item.abbreviated_desc} />
                              </td>
                              <td>{item.item_code}</td>
                              <td>{item.abbreviated_desc}</td>
                              <td>{item.quantity}</td>

                              <td>
                                <input
                                  type="number"
                                  value={item.picked_quantity}
                                  onChange={(e) =>
                                    this.handleQtyChange(i, e.target.value)
                                  } 
                                  className="pol-input-qty"
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* ACTION */}
                <div style={{ marginTop: 30, textAlign: "right" }}>
                    {selectedOrder.sync_status === "pending" ?
                      <button
                        className="pol-primary-btn"
                        onClick={this.confirmPicking}
                      >
                        <AiOutlineCheck />
                        Confirm Picking
                      </button>
                    : null}
                </div>

              </div>
            ) : (
              <div className="pol-empty">
                <h3>Loading order...</h3>
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default PreSalePicking;
